module.exports = __webpack_public_path__ + "img/chongzu.0993e4c6.png";